import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { ElectricMetersListComponent } from 'src/app/modules/electric-meters/pages/electric-meters-list/electric-meters-list.page';
var ɵ0 = {
    permissions: ['canReadPropertiesList']
};
var routes = [
    {
        path: 'list',
        component: ElectricMetersListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var ElectricMetersRoutingModule = /** @class */ (function () {
    function ElectricMetersRoutingModule() {
    }
    return ElectricMetersRoutingModule;
}());
export { ElectricMetersRoutingModule };
export { ɵ0 };
